
import _ from 'lodash'
import {MessageBox} from 'element-ui'

class TokenStorage {
  getToken () {
    return sessionStorage.getItem('token') || localStorage.getItem('token') || undefined
  }

  setToken (token, persist) {
    (!persist ? sessionStorage : localStorage).setItem('token', token)
  }

  removeToken () {
    sessionStorage.removeItem('token')
    localStorage.removeItem('token')
  }

  confirm = _.throttle(() => {
    return MessageBox.alert(
      '当前登录会话已过期，请重新登录。', '提示', {
        confirmButtonText: '重新登录',
        type: 'warning'
      }
    )
  }, 3000, { trailing: false })
}

export default new TokenStorage()



// WEBPACK FOOTER //
// ./src/plugins/tokenStorage/index.js